import { useEffect, useRef } from "react";

/**
 * Scroll the window back to the top whenever `key` changes — but NOT on the
 * initial mount. Used by the blog listings so paginating (which only changes
 * the `?page` search param, not the pathname, so the global ScrollToTop does
 * not fire) brings the new page's posts into view instead of leaving the
 * reader stranded at the bottom where the pager is.
 */
export function useScrollTopOnChange(key: unknown) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) window.scrollTo(0, 0);
    else mounted.current = true;
  }, [key]);
}
